import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { ActionType } from "../state/actions";
import { useTypedSelector } from "./useTypedSelector";

interface UseDiscardAndContinueOptions {
    navigateToHome: () => void;
    setUnsavedDialogOpen: (open: boolean) => void;
}

export const useDiscardAndContinue = ({
    navigateToHome,
    setUnsavedDialogOpen
}: UseDiscardAndContinueOptions) => {
    const dispatch = useDispatch();
    const persistedXPathData = useTypedSelector((state) => state.xPathData.persistedData);
    const persistedPushbackData = useTypedSelector((state) => state.configPushbackDefaults.persistedData);
    const persistedDocumentBundles = useTypedSelector((state) => state.configDocumentBundles.persistedData);
    const persistedEventBundles = useTypedSelector((state) => state.configEventBundles.persistedData);

    return useCallback(() => {
        setUnsavedDialogOpen(false);
        dispatch({ type: ActionType.REVERT_CONFIG_PLUGIN_DATA });
        if (persistedXPathData) {
            dispatch({
                type: ActionType.GET_CONFIG_XPATH_DATA_SUCCESS,
                payload: persistedXPathData,
                fromServer: false
            });
        }
        if (persistedPushbackData) {
            dispatch({
                type: ActionType.GET_CONFIG_PUSHBACK_SUCCESS,
                payload: persistedPushbackData,
                fromServer: false
            });
        }
        if (persistedDocumentBundles) {
            dispatch({
                type: ActionType.GET_CONFIG_BUNDLE_DATA_SUCCESS,
                payload: persistedDocumentBundles,
                fromServer: false
            });
        }
        if (persistedEventBundles) {
            dispatch({
                type: ActionType.GET_CONFIG_BUNDLE_EVENT_DATA_SUCCESS,
                payload: persistedEventBundles,
                fromServer: false
            });
        }
        navigateToHome();
    }, [
        dispatch,
        navigateToHome,
        persistedDocumentBundles,
        persistedEventBundles,
        persistedPushbackData,
        persistedXPathData,
        setUnsavedDialogOpen
    ]);
};
